import type { SystemStyleObject } from "@ecco/ui/theme-tools";
import { focusOutline } from "@ecco/ui/css/focus";

export const localCheckboxStyle: SystemStyleObject = {
    fontSize: "desktopBodyTextSmall",
    transitionProperty: "common",
    transitionDuration: "normal",
    _active: {
        bg: "transparent",
    },
    _focus: {
        ...focusOutline,
        _hover: { outline: "none" },
    },
    _hover: {
        focus: {
            outlineColor: "transparent",
            _disabled: {
                pointerEvents: "none",
                color: "gray.700",
            },
        },
    },
    _disabled: {
        pointerEvents: "none",
        color: "gray.700",
    },
};

export const styles = {
    itemWrapper: {
        display: "grid",
        gridTemplateColumns: "10fr 1fr",
        alignItems: "center",
    },
};
